export default {
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  months_plur: [
    'Januarys',
    'Februarys',
    'Marchs',
    'Aprils',
    'Mays',
    'Junes',
    'Julys',
    'Augusts',
    'Septembers',
    'Octobers',
    'Novembers',
    'Decembers',
  ],
  prevMonth: "Previous month",
  nextMonth: "Next month",
  days: ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su'],
  pagination: {
    label: 'На страницу',
    tooltip: 'Такая страница отсутствует'
  }
}
